import React from "react";

const SidebarPanel = (props) => {
  return (
    <>
      <div className="sidebar-panel">{props.children}</div>
    </>
  );
};

export default SidebarPanel;
